/*
 * Editor de pieza (imagen HQ / embed Vimeo / fuente / ad_id manual de TikTok).
 * Reemplaza, para este panel, el modal "Configurar preview" de marketing.php:
 * aquí el formulario abre con los valores ya guardados (marketing.php lo abre
 * vacío) y guardar no borra un campo salvo que se pida explícitamente con el
 * botón "Quitar".
 */
import React, { useCallback, useEffect, useState } from 'react'
import authAxios from '../../../../config/authAxios'
import { getVimeoSrc, getTikTokEmbedSrc } from '../mediaHelpers'

const PiezaEditorAgente = ({ campaignId, pieza, onClose, onSaved, onNotice, onError }) => {
  const isTikTok = pieza.plataforma === 'tiktok'
  const [fuentes, setFuentes] = useState([])
  const [adsTiktok, setAdsTiktok] = useState([])
  const [form, setForm] = useState({
    url_pieza_hq: pieza.url_pieza_hq || '',
    embed_vimeo: pieza.embed_vimeo || '',
    id_fuente: pieza.id_fuente != null ? String(pieza.id_fuente) : '',
    id_anuncio_manual: pieza.id_anuncio_manual || '',
  })
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    authAxios.get(`/admin/agente-marketing/piezas/opciones?id_camp=${campaignId}`)
      .then(r => { setFuentes(r.data?.data?.fuentes || []); setAdsTiktok(r.data?.data?.ads_tiktok_disponibles || []) })
      .catch(() => {})
  }, [campaignId])

  const previewSrc = pieza.tipo === 'video'
    ? (getVimeoSrc(form.embed_vimeo) || (isTikTok ? getTikTokEmbedSrc(pieza.id_externo) : null))
    : null
  const previewImg = pieza.tipo !== 'video' ? (form.url_pieza_hq || pieza.url_pieza || pieza.thumbnail_url || null) : null

  const save = useCallback(async (overrides) => {
    setSaving(true)
    try {
      const body = { id_camp: campaignId, ...form, ...(overrides || {}) }
      const r = await authAxios.post(`/admin/agente-marketing/piezas/${pieza.id_creative}/configuracion`, body)
      onNotice('Pieza actualizada.')
      onSaved(r.data?.data || {})
    } catch (e) { onError(e.response?.data?.msg || 'No se pudo guardar la pieza.') }
    finally { setSaving(false) }
  }, [campaignId, form, pieza.id_creative, onNotice, onSaved, onError])

  const submit = event => { event.preventDefault(); save() }

  const quitarPreview = () => {
    if (!window.confirm('¿Quitar la vista previa configurada de esta pieza?')) return
    const campo = pieza.tipo === 'video' ? 'embed_vimeo' : 'url_pieza_hq'
    setForm({ ...form, [campo]: '' })
    save({ quitar: [campo] })
  }

  return <div className="am-modal-backdrop" onClick={onClose}>
    <div className="am-modal-card" onClick={e => e.stopPropagation()}>
      <div className="d-flex justify-content-between">
        <h5>Configurar pieza · {pieza.nombre}</h5>
        <button className="close" onClick={onClose}>&times;</button>
      </div>

      <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', background: '#0f172a', borderRadius: 8, overflow: 'hidden', marginBottom: 16 }}>
        {previewSrc
          ? <iframe src={previewSrc} title={pieza.nombre} allow="autoplay;fullscreen;picture-in-picture"
              style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }} />
          : previewImg
            ? <img src={previewImg} alt={pieza.nombre} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain' }} />
            : <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: 28 }}>
                {pieza.tipo === 'video' ? '🎬' : '🖼'} Sin vista previa
              </div>}
      </div>

      <form onSubmit={submit}>
        {pieza.tipo === 'video'
          ? <div className="form-group">
              <label>Vimeo (URL, ID o código &lt;iframe&gt;)</label>
              <textarea className="form-control" rows={2} value={form.embed_vimeo}
                onChange={e => setForm({ ...form, embed_vimeo: e.target.value })}
                placeholder="https://vimeo.com/123456789" />
            </div>
          : <div className="form-group">
              <label>Imagen HQ (URL)</label>
              <input type="text" className="form-control" value={form.url_pieza_hq}
                onChange={e => setForm({ ...form, url_pieza_hq: e.target.value })}
                placeholder="https://..." />
            </div>}

        <div className="form-row">
          <div className="form-group col-md-6">
            <label>Fuente</label>
            <select className="form-control" value={form.id_fuente} onChange={e => setForm({ ...form, id_fuente: e.target.value })}>
              <option value="">— Sin asignar —</option>
              {fuentes.map(f => <option key={f.id_fuente} value={f.id_fuente}>{f.nombre_fuente}</option>)}
            </select>
          </div>
          {isTikTok && <div className="form-group col-md-6">
            <label>Ad ID de TikTok (para vincular leads)</label>
            <select className="form-control" value={form.id_anuncio_manual} onChange={e => setForm({ ...form, id_anuncio_manual: e.target.value })}>
              <option value="">— Sin asignar —</option>
              {adsTiktok.map(id => <option key={id} value={id}>{id}</option>)}
            </select>
          </div>}
        </div>

        <div className="d-flex" style={{ gap: 8 }}>
          <button className="btn btn-primary" disabled={saving}>{saving ? 'Guardando…' : 'Guardar'}</button>
          <button type="button" className="btn btn-outline-danger" disabled={saving} onClick={quitarPreview}>Quitar vista previa</button>
          <button type="button" className="btn btn-link ml-auto" onClick={onClose}>Cancelar</button>
        </div>
      </form>
    </div>
  </div>
}

export default PiezaEditorAgente
